
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { SiteSettings } from "@/lib/supabase";

interface SidebarHeaderProps {
  siteSettings: SiteSettings | null;
  onCloseSidebar?: () => void;
}

const SidebarHeader = ({ siteSettings, onCloseSidebar }: SidebarHeaderProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="p-4 border-b flex justify-between items-center">
      <Link to="/" className="flex items-center gap-2">
        {siteSettings?.logo_url ? (
          <img src={siteSettings.logo_url} alt="Logo" className="h-8 w-8 rounded-lg object-cover" />
        ) : (
          <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
            <span className="text-white font-bold">F</span>
          </div>
        )}
        <span className="font-bold text-xl">{siteSettings?.site_name || "Coach PT"}</span>
      </Link>
      
      {isMobile && <Button variant="ghost" size="icon" onClick={onCloseSidebar} className="md:hidden">
          <X size={18} />
        </Button>}
    </div>
  );
};

export default SidebarHeader;
